import {html, LitElement, PropertyValues} from 'lit';
import {customElement, property, state} from 'lit/decorators.js';
import {imageInputEntry} from './sp-image-input-entry.styles';
import {when} from "lit/directives/when.js";
import {classMap} from "lit/directives/class-map.js";
import {styleMap} from "lit-html/directives/style-map.js";
import {SpTouchDragController} from "../../../../controllers/sp-touch-drag.controller";

@customElement('sp-image-input-entry')
export class SpImageInputEntry extends LitElement {
    @property()
    image: string | Blob
    @property({type: Object})
    canvas?: object
    @property({ type: Boolean })
    movable = true;
    @property({type: String})
    placeholder: string;
    @property() type: 'default' | 'bubble' = 'default';
    @property() uuid: string;

    static styles = [
        imageInputEntry
    ];

    @state()
    imageUrl;

    constructor() {
        super();
        new SpTouchDragController(this);
    }

    protected willUpdate(_changedProperties: PropertyValues) {
        if (_changedProperties.has('image')) {
            if (this.imageUrl) URL.revokeObjectURL(this.imageUrl);
            this.imageUrl = typeof this.image === 'object' ? URL.createObjectURL(this.image) : this.image;
        }
    }

    protected render() {
        return html`
            ${when(this.image && this.movable, ()=> html`
                <sp-drop-zone
                        .mandatoryDataTypes=${ [ `sp-image-input-entry-move-${this.uuid}` ] }
                        invisible
                        @dragenter=${ e => {
                            this.dispatchEvent(new CustomEvent('image-dragenter'));
                        }}>
                </sp-drop-zone>
            `)}
            <div class=${ classMap({
                        image: true,
                        bubble: this.type === 'bubble'
                    })}
                    @click=${this.emitOpenImage}
                    part=${this.image ? 'image' : 'placeholder'}
                    style=${styleMap(this.getImageStyle())}>
            </div>`;
    }

    getImageStyle() {
        return {
            'background-image': `url(${ this.imageUrl ? this.imageUrl : this.placeholder })`
        }
    }

    emitOpenImage() {
        this.dispatchEvent(new CustomEvent('open', {
            detail: {
                image: this.image,
                ...this.canvas && { canvas: this.canvas }
            }
        }));
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.imageUrl) URL.revokeObjectURL(this.imageUrl);
    }
}
